// vocabulary/science.ts
import { VocabPair } from './types';

export const science: VocabPair[] = [
  { word: "Hypothesis", definition: "An educated guess that can be tested" },
  { word: "Photosynthesis", definition: "Process plants use to make food from sunlight" },
  { word: "Ecosystem", definition: "Community of living things and their environment" },
  { word: "Molecule", definition: "Smallest unit of a substance" },
  { word: "Velocity", definition: "Speed in a particular direction" },
  { word: "Gravity", definition: "Force that pulls objects toward Earth" },
  { word: "Evolution", definition: "Change in species over time" },
  { word: "Catalyst", definition: "Something that speeds up a reaction" },
  { word: "Photon", definition: "Particle of light energy" },
  { word: "Enzyme", definition: "Protein that speeds up chemical reactions" },
  { word: "Chromosome", definition: "Structure containing genetic information" },
  { word: "Mitosis", definition: "Process of cell division" },
  { word: "Organism", definition: "Any living thing" },
  { word: "Habitat", definition: "Natural home of an organism" },
  { word: "Adaptation", definition: "Feature that helps organism survive" },
  { word: "Biodiversity", definition: "Variety of life in an ecosystem" },
];